import React from 'react';

import S from 'app/features/landing/productComparison/components/Product/Benefit.styled';

const BenefitCrossIcon = () => (
  <S.Benefit.Cross viewBox="0 0 20 20">
    <path d="M11.18 10l4.4-4.41a.83.83 0 00-1.17-1.18L10 8.82 5.59 4.41a.83.83 0 00-1.18 0 .83.83 0 000 1.18L8.82 10l-4.41 4.41a.83.83 0 001.18 1.18L10 11.18l4.41 4.4a.83.83 0 001.18-1.17L11.18 10z" />
  </S.Benefit.Cross>
);

export default BenefitCrossIcon;
